import $ from 'jquery'
import Swiper, {
    Pagination,
    Navigation
} from 'swiper';
import hoverEffect from 'hover-effect';
import * as dat from 'dat.gui';

// slider hover effect
new hoverEffect({
    parent: document.querySelector('.one'),
    intensity: 0.9,
    image1: './imgs/projects/Pillars-Climate-Change-V2.jpg',
    image2: './imgs/projects/Pillars-Climate-Change-V2.jpg',
    displacementImage: './imgs/projects/Pillars-Climate-Change-V2.jpg'
});


let nextBt = document.getElementById('nextSlideBt')
let prevBt = document.getElementById('prevSlideBt')
let activeSlide_num = document.getElementById('active-slide-index')
let total_slides = document.getElementById('total-slides')

// filter with slider 

let swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    fadeEffect: {
        crossFade: true
    },
    effect: 'fade',
    Navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
    },
});

nextBt.addEventListener('click', function () {
    swiper.slideNext()
})

prevBt.addEventListener('click', function () {
    swiper.slidePrev()
})




swiper.on('slideChange', function () {
    activeSlide_num.innerText = '0' + (swiper.activeIndex + 1)
    total_slides.innerText = ' / 0' + swiper.slides.length;
    $('.split').toggleClass("active");

});



$(".categories span").on("click", function () {
    var filter = $(this).html().toLowerCase();
    var slidesxcol;
    $(".categories span")
    $(".categories span").removeClass("active");
    $(this).addClass("active");

    if (filter == "all") {
        $("[data-filter]").removeClass("non-swiper-slide").addClass("swiper-slide").show();
        if ($(".swiper-slide").length > 6)
            slidesxcol = 3;
        else slidesxcol = 1;
        swiper.destroy();
        swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,

            effect: 'fade',

            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            on: {
                init: function () {
                    activeSlide_num.innerText = '01'
                }
            }

        });


        swiper.on('slideChange', function () {
            activeSlide_num.innerText = '0' + (swiper.activeIndex + 1);
            $('.split').toggleClass("active");

        });

        total_slides.innerText = ' / 0' + swiper.slides.length


    } else {
        $(".swiper-slide").not("[data-filter='" + filter + "']").addClass("non-swiper-slide").removeClass("swiper-slide").hide();
        $("[data-filter='" + filter + "']").removeClass("non-swiper-slide").addClass("swiper-slide").attr("style", null).show();
        if ($(".swiper-slide").length > 6)
            slidesxcol = 3;
        else slidesxcol = 1;
        swiper.destroy();
        swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,

            effect: 'fade',

            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            on: {
                init: function () {
                    activeSlide_num.innerText = '01'


                }
            }
        });
        swiper.on('slideChange', function () {
            activeSlide_num.innerText = '0' + (swiper.activeIndex + 1);
            $('.split').toggleClass("active");

        });
        total_slides.innerText = ' / 0' + swiper.slides.length;


    }
})






var Split = function() {
    this.$t = $(".split");
    this.gridX = 20;
    this.gridY = 15;
    this.w = this.$t.width();
    this.h = this.$t.height();
    this.img = $("img", this.$t).attr("src");
    this.delay = 0.05;
  
    this.create = function() {
      $("div", this.$t).remove();
  
      for (var x = 0; x < this.gridX; x++) {
        for (var y = 0; y < this.gridY; y++) {
          var width = this.w / this.gridX * 101 / this.w + "%",
              height = this.h / this.gridY * 101 / this.h + "%",
              top = this.h / this.gridY * y * 100 / this.h + "%",
              left = this.w / this.gridX * x * 100 / this.w + "%",
              bgPosX = -(this.w / this.gridX * x) + "px",
              bgPosY = -(this.h / this.gridY * y) + "px";
  
          $("<div />")
            .css({
            position:'absolute',
            top: top,
            left: left,
            width: width,
            height: height,
            backgroundImage: "url(" + this.img + ")",
            backgroundPosition: bgPosX + " " + bgPosY,
            backgroundSize: this.w + "px",
            transitionDelay: x * this.delay + y * this.delay + "s"
          })
            .appendTo(this.$t);
        }
      }
    };
  
    this.create();
  
    this.$t.on("click", function() {
      $(this).toggleClass("active");
    }).click();
  };
  
  window.onload = function() {
    var split = new Split();
    var gui = (function datgui() {
    //   var gui = new dat.GUI();
    //   gui.add(split, "gridX", 1, 20).step(1).onChange(function(newValue) {
    //     split.create();
    //   });
    //   gui.add(split, "gridY", 1, 20).step(1).onChange(function(newValue) {
    //     split.create();
    //   });
    //   gui.add(split, "delay", 0, 0.3).step(0.01).onChange(function(newValue) {
    //     split.create();
    //   });
      return gui;
    })();
  
}
